import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 7 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.8 4.7H0V7h1.8v7h2.9V7h2.1L7 4.7H4.7v-1c0-.5.1-.8.6-.8H7V0H4.8c-2.1 0-3 .9-3 2.7z" }, null, -1)
  ])))
}
export default { render: render }